import { Link } from 'react-router-dom';

import { IconChevronRight } from '@snorose/icons';

import styles from './ActivityTab.module.css';
const ActivityTab = ({ userInfo }) => {
  return (
    <>
      <div className={styles.infoWrapper}>
        {[
          {
            label: '내 글 모아보기',
            link: 'my-post',
          },
          {
            label: '댓글 단 글 모아보기',
            link: 'comment',
          },
          {
            label: '다운 받은 시험 후기 모아보기',
            link: 'download-exam-review',
          },
          {
            label: '내 문의 및 신고 모아보기',
            link: 'inquiry-report',
          },
          {
            label: '스크랩한 시험 후기 모아보기',
            link: 'scrap-exam-review',
          },
          {
            label: '스크랩한 글 모아보기',
            link: 'scrap',
          },
        ].map((item, index) => (
          <div className={styles.itemList} key={index}>
            <Link to={item.link}>
              <div className={styles.item}>
                <span>{item.label}</span>
                <IconChevronRight />
              </div>
            </Link>
          </div>
        ))}
      </div>

      <div className={styles.directList}>
        <Link to={'/commerce/orders'}>
          <div className={styles.direct}>
            <div className={styles.text}>
              <span>내 주문 내역</span>
              <span>물품 구매와 강연 신청 내역을 확인해요</span>
            </div>
            <IconChevronRight />
          </div>
        </Link>

        {userInfo.userRoleId === 4 && (
          <Link to={'/commerce/pickup-display'}>
            <div className={styles.direct}>
              <div className={styles.text}>
                <span>수령·입장 확인</span>
                <span>현장에서 수령과 입장을 확인해요</span>
              </div>
              <IconChevronRight />
            </div>
          </Link>
        )}
      </div>
    </>
  );
};

export default ActivityTab;
